import {
  ComponentParams,
  ComponentRendering,
  ImageField,
  Field,
  RichTextField,
  FileField,
} from '@sitecore-jss/sitecore-jss-nextjs';

export interface C43MediaGalleryItemProps {
  rendering?: ComponentRendering & { params?: ComponentParams };
  params?: ComponentParams;
  fields?: C43MediaGalleryItemFields;
}

export interface C43MediaGalleryItemFields {
  Image?: ImageField;
  VideoID?: Field<string>;
  AudioSource?: FileField;
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
}
